module.exports = "<div id=\"msgDiv\" contenteditable=\"false\"\r\n     style=\"color:red;width:100%;border:0px solid #a0b3d6;font-size:16px;text-align:left;white-space:pre-wrap;\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/component/message-info/message-info.component.html
// module id = ./src/app/modules/shared/component/message-info/message-info.component.html
// module chunks = main